import Plx from 'react-plx';

/**
 * Parallax Header
 * @category Functional Component
 * @extends Component
 * @summary Creates a parallax image.
 * @prop {Object} image - The image url.
 * @return {Node} React node containing the parallax image.
 */

const ParallaxHeader = (props) => {
  const { children } = props;
  const parallaxData = [
    {
      start: 'self',
      duration: 300,
      properties: [
        {
          startValue: 0,
          endValue: 150,
          property: 'translateY',
        }
      ],
    }
  ];

  return (
    <>
      <div className='parallax-header'>
        <Plx parallaxData={ parallaxData }>
          { children }
        </Plx>
      </div>
    </>
  );
}

export default ParallaxHeader;
